import { css } from '@emotion/react';

import { transition } from '~/styles/transition';

export const button = ({ theme, buttonSize, disabled }) => css`
    color: ${theme.colors.primary.black};
    background-color: ${theme.colors.primary.yellow};
    ${buttonSize !== 'mini' &&
    `font-size: clamp(1.6rem, ${(19 / theme.layout.fontComp) * 100}vw, 2.6rem);`}
    font-family: ${theme.fonts.heading};
    font-weight: ${theme.fontWeights.bold};
    padding: ${buttonSize === 'mini' ? '0.83em' : '0.9em 1.7em'};
    ${buttonSize === 'mini' && 'border-radius: 50%;'}
    line-height: 1;
    border: 0;
    display: inline-flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    cursor: pointer;
    ${transition({}, 'background-color')};

    &:focus,
    &:hover {
        background-color: ${!disabled && theme.colors.accent.yellow};
    }

    @media (min-width: ${theme.breakpoint.largeTablet}) {
        ${buttonSize !== 'small' &&
        buttonSize !== 'mini' &&
        'padding: 1.38em 2.22em;'}
    }

    ${disabled &&
    `
        opacity: 0.5;
        pointer-events: none;  
    `}
`;
